import React from 'react';
import BaseScreen from '../BaseComponent/BaseScreen';

export default class LoadableBaseScreen extends BaseScreen {
  renderContent() {
    return null;
  }
}
